import { useMemo } from 'react';
import { useUserState } from '../query/UserProvider';
import { extractFollowedCompaniesFromUserState, type FollowedCompany } from '../utils/user-state/extract-followed-companies-from-user-state';

/**
 * TEC-404: reads the TanStack `userState` cache instead of Redux — its writer,
 * `useCompanyFollowActions.ts`, was migrated in the same pass, so the cache this reads is always
 * populated by the write path (both guest-persisted and signed-in cases).
 */
export function useFollowedCompanies(): FollowedCompany[] {
  const { data } = useUserState();
  return useMemo(() => extractFollowedCompaniesFromUserState(data ?? {}), [data]);
}
